import styled from 'styled-components';
import type { TipTokenPrefix } from './types';

type TipsTriggerProps = {
  tokenPrefix: TipTokenPrefix;
  onClick: () => void;
  compact?: boolean;
};

const Button = styled.button<{ $prefix: TipTokenPrefix; $compact?: boolean }>`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  min-width: ${({ $compact }) => ($compact ? '36px' : 'auto')};
  padding: ${({ $compact }) => ($compact ? '0' : '0 12px')};
  border: 1px solid var(--${({ $prefix }) => $prefix}-hairline);
  border-radius: var(--${({ $prefix }) => $prefix}-r-input);
  background: var(--${({ $prefix }) => $prefix}-paper);
  color: var(--${({ $prefix }) => $prefix}-ink);
  font-family: var(--${({ $prefix }) => $prefix}-font-ui);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: var(--${({ $prefix }) => $prefix}-canvas);
  }
`;

const Mark = styled.span<{ $prefix: TipTokenPrefix }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid var(--${({ $prefix }) => $prefix}-navy);
  color: var(--${({ $prefix }) => $prefix}-navy);
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
`;

export const TipsTrigger = ({
  tokenPrefix,
  onClick,
  compact,
}: TipsTriggerProps) => (
  <Button
    type="button"
    $prefix={tokenPrefix}
    $compact={compact}
    onClick={onClick}
    aria-label="Open tips"
    data-tour="tips-trigger"
    title="Tips"
  >
    <Mark $prefix={tokenPrefix} aria-hidden>
      ?
    </Mark>
    {!compact && <span>Tips</span>}
  </Button>
);

export default TipsTrigger;
